<div class="mat">

  <!-- Mini-header mobile: select all + ações -->
  <div class="mobile-header" *ngIf="isSmallScreen && enableSelection">
    <div class="mobile-header-left">
      <button
        mat-icon-button
        matTooltip="Ações"
        [matMenuTriggerFor]="mobileMenu"
        *ngIf="headerActions?.length > 0 && selection.hasValue()">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
    <div class="mobile-header-right">
      <mat-checkbox
        (change)="$event ? masterToggle() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </div>

    <mat-menu #mobileMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let action of headerActions"
        (click)="action.method(getSelectedRows())">
        {{ action.name }}
      </button>
    </mat-menu>
  </div>

  <!-- ========================================== -->
  <!-- MODO ÁRVORE (TREE MODE)                   -->
  <!-- ========================================== -->
  <mat-table
    *ngIf="treeMode"
    [dataSource]="treeDataSource"
    class="custom-table">

    <!-- Coluna de seleção (modo árvore) -->
    <ng-container *ngIf="enableSelection" matColumnDef="select">
      <mat-header-cell *matHeaderCellDef class="checkbox-header">
        <mat-progress-spinner
          *ngIf="isLoadingSelectAll"
          [diameter]="20"
          [mode]="'indeterminate'"
          style="display: inline-block; margin-right: 8px;">
        </mat-progress-spinner>
        <mat-checkbox
          *ngIf="!isLoadingSelectAll"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
        <div *ngIf="headerActions.length > 0">
          <button
            mat-icon-button
            matTooltip="Ações"
            [matMenuTriggerFor]="menuHeader"
            *ngIf="headerActions && selection.hasValue()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuHeader="matMenu">
            <button
              mat-menu-item
              *ngFor="let action of headerActions"
              (click)="action.method(getSelectedRows())">
              {{ action.name }}
            </button>
          </mat-menu>
        </div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let node"
        class="checkbox-cell"
        [attr.data-label]="' '">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? toggleRow(node) : null"
          [checked]="selection.isSelected(node)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Coluna de expansão (modo árvore) -->
    <ng-container matColumnDef="expand">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let node" [style.paddingLeft.px]="node.level * 16">
        <button
          *ngIf="!node.loading"
          mat-icon-button
          [style.visibility]="!node.expandable ? 'hidden' : ''"
          (click)="toggleTreeNode(node)">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <mat-progress-spinner
          *ngIf="node.loading"
          class="example-margin"
          [diameter]="25"
          [mode]="'indeterminate'">
        </mat-progress-spinner>
      </mat-cell>
    </ng-container>

    <!-- Colunas dinâmicas (modo árvore) -->
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.def">
      <mat-header-cell
        *matHeaderCellDef
        [style.min-width]="isSmallScreen ? 'auto' : (column.minWidth || 'auto')"
        [ngClass]="{ 'acoesHeader': column.def === 'acaoTable' }">
        {{ column.header }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let node"
        [attr.data-label]="column.header"
        [style.paddingLeft.px]="column.def !== 'acaoTable' ? (node.level + 1) * 32 : 0"
        [style.min-width]="isSmallScreen ? 'auto' : (column.minWidth || 'auto')"
        [ngClass]="{ 'acoes': column.def === 'acaoTable' }">

        <ng-container *ngIf="column.cellTemplate; else builtInTree">
          <ng-container
            *ngTemplateOutlet="column.cellTemplate; context: { $implicit: node }">
          </ng-container>
        </ng-container>

        <ng-template #builtInTree>
          <ng-container *ngIf="column.def === 'valor_cash'; else notCashTree">
            {{ getNestedValue(node, column.def) | currency }}
          </ng-container>
          <ng-template #notCashTree>
            <ng-container *ngIf="column.def === 'acaoTable'" stickyEnd>
              <button
                mat-icon-button
                matTooltip="Ações"
                [matMenuTriggerFor]="menuTree"
                *ngIf="actions ? getVisibleActions(node)?.length>0 : false">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menuTree="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let action of getVisibleActions(node)"
                  (click)="action.method(node)">
                  {{ action.name }}
                </button>
              </mat-menu>
              <button
                class="duplicar"
                mat-mini-fab
                matTooltip="Duplicar"
                (click)="duplicar(node)"
                *ngIf="onDuplicar">
                <mat-icon>copy</mat-icon>
              </button>
              <button
                mat-mini-fab
                matTooltip="Editar"
                (click)="editar(node)"
                class="editar mat-primary"
                *ngIf="onEditar">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-mini-fab
                class="mat-warn warn"
                matTooltip="Excluir"
                (click)="excluir(node)"
                *ngIf="onExcluir">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="column.def !== 'acaoTable'">
              <!-- Se for a coluna de ID, mostra o caminho completo (ex: 10.11.13) -->
              <span *ngIf="column.def === treeIdProperty; else notIdColumn">
                {{ getFullIdPath(node) }}
              </span>

              <ng-template #notIdColumn>
                <span
                  *ngIf="isValidDate(getNestedValue(node, column.def)); else maybeNumberTree">
                  {{ getNestedValue(node, column.def) | date: 'dd/MM/yyyy' }}
                </span>
                <ng-template #maybeNumberTree>
                  <span
                    *ngIf="isNumeric(getNestedValue(node, column.def)); else rawTextTree">
                    {{ formatNumber(getNestedValue(node, column.def)) }}
                  </span>
                </ng-template>
                <ng-template #rawTextTree>
                  <span
                    *ngIf="getNestedValue(node, column.def) !== '1950-01-01T00:00:00'">
                    {{ getNestedValue(node, column.def) }}
                  </span>
                </ng-template>
              </ng-template>
            </ng-container>
          </ng-template>
        </ng-template>

      </mat-cell>
    </ng-container>

    <!-- Linhas (modo árvore) -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns;"
      class="text-uppercase"
      [ngClass]="getTreeLevelClass(row)">
    </mat-row>

  </mat-table>

  <!-- ========================================== -->
  <!-- MODO TABELA NORMAL                        -->
  <!-- ========================================== -->
  <mat-table
    *ngIf="!treeMode"
    [dataSource]="dataSource"
    matColumnResize
    matSort
    class="custom-table">

    <!-- Coluna de seleção -->
    <ng-container *ngIf="enableSelection" matColumnDef="select">
      <mat-header-cell *matHeaderCellDef class="checkbox-header">
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
        <div *ngIf="headerActions.length > 0">
          <button
            mat-icon-button
            matTooltip="Ações"
            [matMenuTriggerFor]="menuHeader"
            *ngIf="headerActions && selection.hasValue()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menuHeader="matMenu">
            <button
              mat-menu-item
              *ngFor="let action of headerActions"
              (click)="action.method(getSelectedRows())">
              {{ action.name }}
            </button>
          </mat-menu>
        </div>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row"
        class="checkbox-cell"
        [attr.data-label]="' '">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? toggleRow(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <!-- Demais colunas -->
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.def">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header="{{ column.def }}"
        [style.min-width]="isSmallScreen ? 'auto' : (column.minWidth || 'auto')"
        [ngClass]="{ 'acoesHeader': column.def === 'acaoTable' }">
        {{ column.header }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        [attr.data-label]="column.header"
        [style.min-width]="isSmallScreen ? 'auto' : (column.minWidth || 'auto')"
        [ngClass]="{ 'acoes': column.def === 'acaoTable' }">

        <ng-container *ngIf="column.cellTemplate; else builtIn">
          <ng-container
            *ngTemplateOutlet="column.cellTemplate; context: { $implicit: element }">
          </ng-container>
        </ng-container>

        <ng-template #builtIn>
          <ng-container *ngIf="column.def === 'valor_cash'; else notCash">
            {{ getNestedValue(element, column.def) | currency }}
          </ng-container>
          <ng-template #notCash>
            <ng-container *ngIf="column.def === 'acaoTable'" stickyEnd>
              <button
                mat-icon-button
                matTooltip="Ações"
                [matMenuTriggerFor]="menu"
                *ngIf="actions ? getVisibleActions(element)?.length>0 : false">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  *ngFor="let action of getVisibleActions(element)"
                  (click)="action.method(element)">
                  {{ action.name }}
                </button>
              </mat-menu>
              <button
                class="duplicar"
                mat-mini-fab
                matTooltip="Duplicar"
                (click)="duplicar(element)"
                *ngIf="onDuplicar">
                <mat-icon>copy</mat-icon>
              </button>
              <button
                [disabled]="BloquearEdicao"
                mat-mini-fab
                matTooltip="Editar"
                (click)="editar(element)"
                class="editar mat-primary"
                *ngIf="onEditar">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                [disabled]="BloquearEdicao"
                mat-mini-fab
                class="mat-warn warn"
                matTooltip="Excluir"
                (click)="excluir(element)"
                *ngIf="onExcluir">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="column.def !== 'acaoTable'">
              <span
                *ngIf="isValidDate(getNestedValue(element, column.def)); else maybeNumber">
                {{ getNestedValue(element, column.def) | date: 'dd/MM/yyyy' }}
              </span>
              <ng-template #maybeNumber>
                <span
                  *ngIf="isNumeric(getNestedValue(element, column.def)); else rawText">
                  {{ formatNumber(getNestedValue(element, column.def)) }}
                </span>
              </ng-template>
              <ng-template #rawText>
                <span
                  *ngIf="getNestedValue(element, column.def) !== '1950-01-01T00:00:00'">
                  {{ getNestedValue(element, column.def) }}
                </span>
              </ng-template>
            </ng-container>
          </ng-template>
        </ng-template>

      </mat-cell>
    </ng-container>

    <!-- Linhas -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns;"
      class="text-uppercase">
    </mat-row>

  </mat-table>

  <!-- Paginador -->
  <mat-paginator
    *ngIf="enablePagination"
    (page)="pageChange.emit($event)"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[10, 25, 50, 100, 500, 1000]"
    showFirstLastButtons>
</mat-paginator>
</div>
